<template>
  <div class="login">
    <div style="width:100%;text-align:center;">
      <!-- <b-card title="Store and Share Your Recipes" style="width:90%;border-radius:15px">
        
        <b-card-body>
          <b-card-img src="https://cdn.pixabay.com/photo/2014/12/15/13/40/bell-pepper-569070_1280.jpg" style="border-radius:15px;" class="" />

        </b-card-body>
      </b-card> -->
      <b-card title="" style="width:90%;border-radius:15px"  class="overflow-hidden">
        <h1>Create, store and share recipes. It's free!</h1>
        <b-card-body>
          <b-card-text>
            <em>Culinary</em> gives you a beautiful page to create and share recipes. Your recipe data is kept secure using the blockchain, so those old family secrets will be secure! If you choose to share a receipe, it will be available publicly.
          </b-card-text>
          
          <h3 class="mt-4">What kind of recipes will you create?</h3>
          <!-- <b-card-text>
            Check out the samples below:
          </b-card-text> -->
        </b-card-body>
        <b-list-group flush>
          <b-list-group-item>
            <h4>Sample Recipes</h4>
            Check out this sample recipe of a "new classic": <a href="https://culinary.cabinetapps.com/shared/thewilliam.id.blockstack/00faee3e-3f59-41ae-bd52-50602c2d56db" target="_blank" style="color:red">French Fried Rice</a>
          </b-list-group-item>
          <!-- <b-list-group-item>
            <h4>Be Inspirational</h4>
            Check out this shard list of <a href="https://listolinks.cabinetapps.com/u/thewilliam.id.blockstack/f732161e-c605-4de0-8b87-a44cb4737b0b" target="_blank">Inspirational Quotes</a>
          </b-list-group-item>
          <b-list-group-item>
            <h4>Be Silly</h4>
            Check out this shared list of <a href="https://listolinks.cabinetapps.com/u/thewilliam.id.blockstack/d49d7620-8a0c-4a0c-83a2-9b4ae47fea45" target="_blank">Famous Products with O' in the Name</a>
          </b-list-group-item> -->
        </b-list-group>

        <b-card-img src="https://cdn.pixabay.com/photo/2014/12/15/13/40/bell-pepper-569070_1280.jpg" style="border-radius:15px;width:50%;padding:10px" class="mt-4" alt="Image" left></b-card-img>
      </b-card>
      <h2 style="color:white" class="m-5">Try it today!</h2>
      <b-button class="fe-pulse-w-pause" variant="light" @click="signIn">Sign in with Blockstack</b-button>

    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields([
      'blockstack.user',
      'blockstack.userSession',
      'blockstack.user.username'
    ]),
  },
  created() {
    this.$store.dispatch('setUserSession')
  },
  mounted() {
    // this.$store.dispatch('nukeData')
    // console.log('Home Mounted')
    if (this.userSession.isUserSignedIn()) {
      // console.log("user is signed in");
      this.$store.dispatch('setUserProperties').then(() => {
        // this.$store.dispatch('load')
        // console.log('switching to lists...')
        this.$router.push('/recipes')
      })
      
    } else if (userSession.isSignInPending()) {
      // console.log("signinpending")
      this.userSession.handlePendingSignIn().then(userData => {
        // console.log("user pending log in finished");
        // this.$store.dispatch('load')
        window.location = window.location.origin
        this.$router.push('/recipes')
      });
    }

    // console.log("Login mounted routine finished...");
  },
  methods: {
    signIn() {
      this.$store.dispatch('signIn')
    }
  }
}
</script>

<style scoped>
.card {
  margin: 0 auto; /* Added */
  float: none; /* Added */
  margin-bottom: 10px; /* Added */
}

.displaycard {
  padding:10px;
  width: 100%;
  max-width:300px;
  color:black;
  text-align:left;
  border-radius:15px
}

@keyframes pulse {
  from { transform: scale(1); }
  50% { transform: scale(1.05); }
  to { transform: scale(1); }
}

.fe-pulse-w-pause {
  animation-name: pulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.fe-pulse-w-pause:hover,
.fe-pulse-w-pause:focus {
  animation-name: unset;
}
</style>